import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';
import { ARConstants } from '../../../../cirabooks-module/_constants/cb-ar-constants';
const ɵ0 = () => DimensionOptionResultDto;
export class JournalEntryItemResultDto {
    getDebitCreditAmount() {
        if (this.debitOrCredit === ARConstants.DEBIT_CODE) {
            this.debit = this.amount;
        }
        else if (this.debitOrCredit === ARConstants.CREDIT_CODE) {
            this.credit = this.amount;
        }
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], JournalEntryItemResultDto.prototype, "dimensions", void 0);
export { ɵ0 };
